import { HeadingDesc, SectionHeadingSmall } from '../../Headings';
import './iconCard.css';

function IconCard(props) {
  const { img, heading, desc } = props;
  return (
    <div className="iconCard">
      <div className="img_box">
        <img src={img} alt="" />
      </div>
      <div className="card_body">
        <SectionHeadingSmall text={heading} />
        <HeadingDesc text={desc} />
      </div>
    </div>
  );
}

export default IconCard;
